import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    filterInProgress: false,
    editMode: false,
    exportLoading: false,
    departments: [],
    costCenters: [],
    metadataColumns: null,
    publishers: null,
    stakeholders: null,
    productTypes: null,
    tableState: {
      filter: null,
      chipFilter: null,
      columns: null
    }
  }),

  getters: {
    optionsFetched: state => state.publishers && state.stakeholders
  },

  mutations: {
    setFilterInProgress: (state, payload) => (state.filterInProgress = payload),
    setEditMode: (state, payload) => (state.editMode = payload),
    setExportLoading: (state, payload) => (state.exportLoading = payload),
    setDepartments: (state, payload) => (state.departments = payload),
    setMetadataColumns: (state, payload) => (state.metadataColumns = payload),
    setPublishers: (state, payload) => (state.publishers = payload),
    setStakeholders: (state, payload) => (state.stakeholders = payload),
    setProductTypes: (state, payload) => (state.productTypes = payload),
    setTableStateFilter: (state, payload) => (state.tableState.filter = payload),
    setTableStateChipFilter: (state, payload) => (state.tableState.chipFilter = payload),
    setTableStateColumns: (state, payload) => (state.tableState.columns = payload),
    setCostCenters: (state, payload) => (state.costCenters = payload),
    changeChipFilters: (state, chipFilter) => {
      let filters = [...state.tableState.chipFilter]
      if (filters.includes(chipFilter)) filters = filters.filter(f => f !== chipFilter)
      else filters.push(chipFilter)

      state.tableState.chipFilter = filters
    }
  },

  actions: {
    getAndSetDepsMetadataAndTableState({ commit }) {
      return Promise.all([
        apiTo.GET_DEPARTMENTS(),
        apiTo.GET_METADATA_COLUMNS_FOR_ENTITY('subscription-period'),
        apiTo.GET_LIST_VIEW_TABLE_STATE('subscriptions'),
        apiTo.GET_COST_CENTERS()
      ]).then(([{ data: departments }, { data: metadata }, { data: subsTableState }, { data: costCenters }]) => {
        commit('setDepartments', departments.result)
        commit('setMetadataColumns', metadata.result)
        commit('setTableStateFilter', subsTableState.result.filter)
        commit('setTableStateChipFilter', subsTableState.result.chip_filter || [])
        commit('setTableStateColumns', subsTableState.result.columns)
        commit('setCostCenters', costCenters.result)
      })
    },

    getOptions({ commit }) {
      return Promise.all([apiTo.GET_PUBLISHERS(), apiTo.GET_STAKEHOLDERS(), apiTo.GET_PRODUCT_TYPES()]).then(
        ([{ data: publishers }, { data: stakeholders }, { data: productTypes }]) => {
          commit('setPublishers', publishers.result)
          commit('setStakeholders', stakeholders.result)
          commit('setProductTypes', productTypes.result)
        }
      )
    },

    saveTableState({ state }) {
      apiTo.MODIFY_LIST_VIEW_TABLE_STATE('subscriptions', {
        filter: state.tableState.filter,
        columns: state.tableState.columns,
        chip_filter: state.tableState.chipFilter
      })
    }
  }
}
